@if (loading()) {
<div
  class="staff-kpi-card staff-kpi-card--skeleton"
  [class.staff-kpi-card--align-start]="align() === 'start'"
  [class.staff-kpi-card--label-first]="labelFirst()"
  aria-hidden="true"
>
  @if (labelFirst()) {
  <span class="staff-kpi-card__label staff-kpi-card__label--skeleton"></span>
  <span class="staff-kpi-card__value staff-kpi-card__value--skeleton"></span>
  } @else {
  <span class="staff-kpi-card__value staff-kpi-card__value--skeleton"></span>
  <span class="staff-kpi-card__label staff-kpi-card__label--skeleton"></span>
  }
</div>
} @else if (clickable()) {
<button
  type="button"
  class="staff-kpi-card"
  [class.staff-kpi-card--highlight]="highlight()"
  [class.staff-kpi-card--tone-debtor]="tone() === 'debtor'"
  [class.staff-kpi-card--tone-wallet]="tone() === 'wallet'"
  [class.staff-kpi-card--prominent]="size() === 'prominent'"
  [class.staff-kpi-card--align-start]="align() === 'start'"
  [class.staff-kpi-card--label-first]="labelFirst()"
  (click)="onClick()"
>
  <ng-container *ngTemplateOutlet="cardBody" />
</button>
} @else {
<div
  class="staff-kpi-card"
  [class.staff-kpi-card--highlight]="highlight()"
  [class.staff-kpi-card--tone-debtor]="tone() === 'debtor'"
  [class.staff-kpi-card--tone-wallet]="tone() === 'wallet'"
  [class.staff-kpi-card--prominent]="size() === 'prominent'"
  [class.staff-kpi-card--align-start]="align() === 'start'"
  [class.staff-kpi-card--label-first]="labelFirst()"
>
  <ng-container *ngTemplateOutlet="cardBody" />
</div>
}

<ng-template #cardBody>
  @if (labelFirst()) {
  <span class="staff-kpi-card__label">{{ labelKey() | translate }}</span>
  }
  <span class="staff-kpi-card__value">{{ value() }}</span>
  @if (deltaLabel(); as deltaLabel) {
  <span
    class="staff-kpi-card__delta"
    [class.staff-kpi-card__delta--up]="deltaTone() === 'up'"
    [class.staff-kpi-card__delta--down]="deltaTone() === 'down'"
    [class.staff-kpi-card__delta--flat]="deltaTone() === 'flat'"
  >
    {{ deltaLabel }}
  </span>
  }
  @if (!labelFirst() && metricKind(); as kind) {
  <span class="staff-kpi-card__kind">
    {{
      kind === 'snapshot'
        ? ('STAFF.DASHBOARD.METRIC.SNAPSHOT' | translate)
        : ('STAFF.DASHBOARD.METRIC.PERIOD' | translate)
    }}
  </span>
  }
  @if (hintKey(); as hintKey) {
  <span class="staff-kpi-card__hint">{{ hintKey | translate: hintParams() }}</span>
  }
  @if (!labelFirst()) {
  <span class="staff-kpi-card__label">{{ labelKey() | translate }}</span>
  }
</ng-template>
